import * as THREE from "three";

export const WOOD = [
  {
    name: "Oak",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Oak1/oak_side_color.jpg",
    normalMap: "./textures/wood4k/side/Oak1/oak_side_normal.jpg",
    roughnessMap: "./textures/wood4k/side/Oak1/oak_side_roughness.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Africa Walnut 1",
    listName: "WOOD",
    texture:
      "./textures/wood4k/side/AfricanWalnut1/africanwalnut1_side_color.jpg",
    roughnessMap:
      "./textures/wood4k/side/AfricanWalnut1/africanwalnut1_side_roughness.jpg",
    normalMap:
      "./textures/wood4k/side/AfricanWalnut1/africanwalnut1_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Africa Walnut 2",
    listName: "WOOD",
    texture:
      "./textures/wood4k/side/AfricanWalnut2/africanwalnut2_side_color.jpg",
    roughnessMap:
      "./textures/wood4k/side/AfricanWalnut2/africanwalnut2_side_roughness.jpg",
    normalMap:
      "./textures/wood4k/side/AfricanWalnut2/africanwalnut2_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Pine",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Pine/pine_side_color.jpg",
    roughnessMap: "./textures/wood4k/side/Pine/pine_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Pine/pine_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Pine Clear",
    listName: "WOOD",
    texture: "./textures/wood4k/side/PineClear/pineclear_side_color.jpg",
    roughnessMap:
      "./textures/wood4k/side/PineClear/pineclear_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/PineClear/pineclear_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Maple",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Maple/maple_side_color.jpg",
    roughnessMap: "./textures/wood4k/side/Maple/maple_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Maple/maple_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "American Walnut",
    listName: "WOOD",
    texture:
      "./textures/wood4k/side/AmericanWalnut/americanwalnut_side_color.jpg",
    roughnessMap:
      "./textures/wood4k/side/AmericanWalnut/americanwalnut_side_roughness.jpg",
    normalMap:
      "./textures/wood4k/side/AmericanWalnut/americanwalnut_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Cherry",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Cherry/cherry_side_color.jpg",
    roughnessMap: "./textures/wood4k/side/Cherry/cherry_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Cherry/cherry_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Mahogany",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Mahogany/mahogany_side_color.jpg",
    roughnessMap: "./textures/wood4k/side/Mahogany/mahogany_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Mahogany/mahogany_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Lime",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Lime/lime_side_color.webp",
    roughnessMap: "./textures/wood4k/side/Lime/lime_side_roughness.webp",
    normalMap: "./textures/wood4k/side/Lime/lime_side_normal.webp",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Silver",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Silver/silver_side_color.jpg",
    roughnessMap: "./textures/wood4k/side/Silver/silver_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Silver/silver_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 0.8,
    metalness: 0.1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 3,
  },
  {
    name: "Gold",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Gold/gold_side_color.jpg",
    roughnessMap: "./textures/wood4k/side/Gold/gold_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Gold/gold_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 0.8,
    metalness: 0.1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 3,
  },
  {
    name: "Dark Walnut",
    listName: "WOOD",
    texture: "./textures/wood4k/side/DarkWalnut/darkwalnut_side_color.jpg",
    roughnessMap:
      "./textures/wood4k/side/DarkWalnut/darkwalnut_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/DarkWalnut/darkwalnut_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Wenga",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Wenga/wenga_side_color_c.jpg",
    roughnessMap: "./textures/wood4k/side/Wenga/wenga_side_roughness.jpg",
    normalMap: "./textures/wood4k/side/Wenga/wenga_side_normal.jpg",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Beech",
    listName: "WOOD",
    texture: "./textures/wood4k/side/Beech/Beech_Side_Color.jpg",
    roughnessMap: "./textures/wood4k/side/Beech/Beech_Side_Roughness.jpg",
    normalMap: "./textures/wood4k/side/Beech/Beech_Side_Normal.png",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Wash White",
    listName: "WOOD",
    texture: "./textures/wood4k/side/PineWash/PineWash_Side_Color.jpg",
    roughnessMap: "./textures/wood4k/side/PineWash/PineWash_Side_Roughness.jpg",
    normalMap: "./textures/wood4k/side/PineWash/PineWash_Side_Normal.png",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  }
];
